import { Button, ButtonColorVariant, ButtonSize } from '@gousto-internal/citrus-react'
import React from 'react'
import type { HandleOnClick, TopInStockRecipe } from '../../types/curatedBoxTypes'

type CuratedBoxButtonProps = {
  handleRecipes: HandleOnClick
  recipes: TopInStockRecipe[]
  curatedBoxCollectionId: string
  title: string
  isPrimary: boolean
  buttonText: string
}

export const CuratedBoxButton = ({
  handleRecipes,
  recipes,
  curatedBoxCollectionId,
  title,
  isPrimary,
  buttonText,
}: CuratedBoxButtonProps) => {
  const handleEvent = () => {
    const recipeIds = recipes.map((recipe) => recipe?.recipeId) as string[]
    handleRecipes(recipeIds, curatedBoxCollectionId, title)
  }

  const handleAddCuratedBox = (event: React.SyntheticEvent<HTMLElement>) => {
    event.stopPropagation()
    handleEvent()
  }

  return (
    <Button
      data-testid="curated-box-add-box-button"
      tabIndex={0}
      colorVariant={isPrimary ? ButtonColorVariant.Primary : ButtonColorVariant.Secondary}
      width="100%"
      onClick={handleAddCuratedBox}
      size={ButtonSize.Large}
    >
      {buttonText}
    </Button>
  )
}
